const firebaseDevConfig = {
  apiKey: 'AIzaSyBlSX9AtaAfaQwRF-AZf0W1KSU38DrEBZk',
  authDomain: 'elytiz-admin-dev.firebaseapp.com',
  databaseURL: 'https://elytiz-app-dev.firebaseio.com',
  projectId: 'elytiz-app-dev',
  storageBucket: 'elytiz-app-dev.appspot.com',
  messagingSenderId: '850315005422',
  appId: '1:850315005422:web:639c96b85fe8eac8',
}

const firebaseProdConfig = {
  apiKey: 'AIzaSyAQjtWgBRRoIlIEvVTNUzg62ogP-IhPsPk',
  authDomain: 'elytiz-app-prod.firebaseapp.com',
  databaseURL: 'https://elytiz-app-prod.firebaseio.com',
  projectId: 'elytiz-app-prod',
  storageBucket: 'elytiz-app-prod.appspot.com',
  messagingSenderId: '514613277551',
  appId: '1:514613277551:web:da3371e8e6712b3d',
}


export const DRAWER_WIDTH = 250

export const ROUTES = {
  HOME: '/admin',
  USER: '/admin/user',
  MAGIC: '/admin/magic',
  MODELS: '/admin/models',
  CLIENTS: '/admin/clients',
  CASTINGS: '/admin/castings',
  REJECTED: '/admin/rejected',
  PHOTOGRAPHERS: '/admin/photographers',
}

export const LIST_TYPE = {
  USER: 'USER',
  MODEL: 'MODEL',
  CLIENT: 'CLIENT',
  CASTING: 'CASTING',
  PHOTOGRAPHER: 'PHOTOGRAPHER',
  WAITINGLIST: 'WAITINGLIST',
}

export const IS_DEV = process.env.REACT_APP_ENV !== 'production'

export const FIREBASE_CONFIG = IS_DEV ? firebaseDevConfig : firebaseProdConfig

export const ELYTIZ_URL = IS_DEV ? 'https://elytiz-app-dev.web.app' : 'https://elytiz-app-prod.web.app'

export const USER_TYPE = {
  ALL: 'all',
  MODEL: '0',
  PHOTOGRAPHER: '1',
}

export const GENDER = {
  MALE: '0',
  FEMALE: '1',
  OTHER: '2',
}

export const VALIDATION_STATUS = {
  PENDING: 'pending',
  DISMISSED: 'dismissed',
  SHORTLISTED: 'shortlisted',
}
